import { render, staticRenderFns } from "./CalendarForm.vue?vue&type=template&id=564b4265&scoped=true&"
import script from "./CalendarForm.vue?vue&type=script&lang=js&"
export * from "./CalendarForm.vue?vue&type=script&lang=js&"
import style0 from "./CalendarForm.vue?vue&type=style&index=0&id=564b4265&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564b4265",
  null
  
)

export default component.exports